import { JSX } from 'react'

import { IconProps } from '../../icon'

const HamMenu: (props: IconProps) => JSX.Element = ({
  dataTestId,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill='none'
    height={height || 48}
    id={id}
    stroke={stroke}
    viewBox='0 0 48 48'
    width={width || 48}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <path
      d='M37.9229 35.7912H10.0778C8.93016 35.7912 8 34.9115 8 33.826C8 32.7406 8.93016 31.8608 10.0778 31.8608H37.9222C39.0698 31.8608 40 32.7406 40 33.826C40 34.9115 39.0705 35.7912 37.9229 35.7912Z'
      fill='black'
    />
    <path
      d='M37.9229 25.8608H10.0778C8.93016 25.8608 8 24.9811 8 23.8956C8 22.8102 8.93016 21.9304 10.0778 21.9304H37.9222C39.0698 21.9304 40 22.8102 40 23.8956C40.0007 24.9811 39.0705 25.8608 37.9229 25.8608Z'
      fill='black'
    />
    <path
      d='M37.9229 15.9304H10.0778C8.93016 15.9304 8 15.0506 8 13.9652C8 12.8798 8.93016 12 10.0778 12H37.9222C39.0698 12 40 12.8798 40 13.9652C40 15.0506 39.0705 15.9304 37.9229 15.9304Z'
      fill='black'
    />
  </svg>
)

export default HamMenu
